import { About } from './About';

export default About;
